import { render, staticRenderFns } from "./editPaidEsportsTorunament.vue?vue&type=template&id=636c71a2&"
import script from "./editPaidEsportsTorunament.vue?vue&type=script&lang=js&"
export * from "./editPaidEsportsTorunament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports